export const QueryKeysConfig = {
  postBySlug: "post-by-slug",
  postsByTag: "posts-by-tag",
  rootPosts: "posts",
  postComments: "post-comments",
  postTags: "post-tags",
  observation: "observation",
  postObservationsRsc: "post-observations-rsc",
  latestObservations: "latestObservations",
  latestComments: "latest-comments",
  searchPostsByTerm: "search-posts-by-term",
  colorScheme: "color-scheme",
  likedPosts: "liked-posts",
  appMenuSect: "app-menu-sect",
  serverTimezone: "server-tz",
  clientTimezone: "client-tz",
  wpAdminAuth: "wp-admin-auth",
};
